import React, { Component } from 'react';
import {
    Grid,
    Row,
    Col,
    Tabs,
    Tab,
} from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Card from '../../components/Card/Card.jsx';
import AlertError from '../Components/AlertError.jsx';
import CreateConvocatoria from './CreateConvocatoria.jsx';
import UpdateConvocatoria from './UpdateConvocatoria.jsx';
import IncubationService from "../../services/IncubationService";
import ProyectService from "../../services/ProyectService";
import UserService from "../../services/UserService";
import { getTable, refreshSelected } from '../Components/JQueryTable/JQueryTableLogic.jsx';
import Convocatoria from './Convocatoria';
import Idea from './Idea';
import IncubationTab from './IncubationTab';
import PreIncubationTab from './PreIncubationTab';
import PreSelectionTab from './PreSelectionTab';
import PostIncubationTab from "./PostIncubationTab";

class Main extends Component{
  constructor(props){
    super(props);
    this.state = {
        alert: null,
        modal: null,
        key: localStorage.getItem('activeTabMain') ? parseInt(localStorage.getItem('activeTabMain'), 10) : 2,
        convocatorias: null,
        estados: null,
        users: [],
    };
    this.userService = new UserService();
    this.incubationService = new IncubationService();
    this.proyectService = new ProyectService();
    this.handleSelect = this.handleSelect.bind(this);
    this.closeCreateModal = this.closeCreateModal.bind(this);
    this.closeUpdateModal = this.closeUpdateModal.bind(this);
    this.createModal = this.createModal.bind(this);
    this.updateModal = this.updateModal.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.preSelect = this.preSelect.bind(this);
    this.preIncubate = this.preIncubate.bind(this);
    this.incubate = this.incubate.bind(this);
    this.postIncubate = this.postIncubate.bind(this);
    this.archive = this.archive.bind(this);
    this.getConvocatorias = this.getConvocatorias.bind(this);
    this.getUsers = this.getUsers.bind(this);
    this.assignProject = this.assignProject.bind(this);
  }
  componentDidMount() {
    this.getConvocatorias();
    this.getUsers();
    this.incubationService.getProjectsStatus()
      .then(res => {
        this.setState({ estados: res.estado });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaban los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  getConvocatorias() {
    this.incubationService.getAnnouncementNumbers()
      .then(res => {
        this.setState({ convocatorias: res.convocatoria });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaban los datos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }
  showAlert(message) {
    this.setState({
      alert: message
    });
  }
  handleSelect(key){
    localStorage.setItem('activeTabMain', key);
    this.setState({key});
  }
  closeCreateModal() {
    this.setState({ modal: null });
  }
  closeUpdateModal() {
    this.setState({ modal: null });
  }
  errorAlert(message) {
    this.setState({
      alert: (
        <AlertError hideAlert={this.hideAlert} message={message} />
      )
    });
  }

  refreshTables() {
    const tableIdea = getTable("idea");
    tableIdea.clear();
    tableIdea.ajax.reload();
    tableIdea.draw();
    const tablePreInc = getTable("preIncubationTab");
    tablePreInc.clear();
    tablePreInc.ajax.reload();
    tablePreInc.draw();
    const tableInc = getTable("incubationTab");
    tableInc.clear();
    tableInc.ajax.reload();
    tableInc.draw();
    const tableGraduados = getTable("postIncubationTab");
    tableGraduados.clear();
    tableGraduados.ajax.reload();
    tableGraduados.draw();
  }

  preSelect(idsProyectos) {
    this.incubationService
      .preSelect(idsProyectos)
      .then(res => {
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Proyectos pre-seleccionados satisfactoriamente!</div>), 10);
        this.hideAlert();
        this.refreshTables();
      })
      .catch(err => {
        console.log(err);
        this.hideAlert();
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaba la información de los proyectos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  preIncubate(idsProyectos) {
    this.incubationService
      .preIncubate(idsProyectos)
      .then(() => {
        idsProyectos.forEach((id) => {
          this.proyectService
          .setInitialTasks(id)
          .then(res2 => {
            // do nothing?
          })
          .catch(err => {
            this.hideAlert();
            this.errorAlert(
              <div>
                Ha ocurrido un error mientras se guardaba la información de los proyectos, el servidor ha
                devuelto la siguiente información: <p>{err.message}</p>
              </div>
            );
          });
        });
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Proyectos pre-incubados satisfactoriamente!</div>), 10);
        this.hideAlert();
        this.refreshTables();
      })
      .catch(err => {
        console.log(err);
        this.hideAlert();
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaba la información de los proyectos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  incubate(idsProyectos) {
    this.incubationService
      .incubate(idsProyectos)
      .then(() => {
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Proyectos incubados satisfactoriamente!</div>), 10);
        this.hideAlert();
        this.refreshTables();
      })
      .catch(err => {
        console.log(err);
        this.hideAlert();
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaba la información de los proyectos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  postIncubate(idsProyectos) {
    this.incubationService
      .postIncubate(idsProyectos)
      .then(() => {
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Proyectos Graduados satisfactoriamente!</div>), 10);
        this.hideAlert();
        this.refreshTables();
      })
      .catch(err => {
        console.log(err);
        this.hideAlert();
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaba la información de los proyectos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  archive(idsProyectos) {
    this.incubationService
      .archive(idsProyectos)
      .then(() => {
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Proyectos Graduados satisfactoriamente!</div>), 10);
        this.hideAlert();
        this.refreshTables();
      })
      .catch(err => {
        console.log(err);
        this.hideAlert();
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaba la información de los proyectos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  createModal(number) {
    this.setState({
      modal: (
        <CreateConvocatoria
          closeCreateModal={this.closeCreateModal}
          setError={this.errorAlert}
          pushNotification={this.props.pushNotification}
          number={number}
          jumpToConvocatoriaTab={() => this.handleSelect(1)}
          incubationService={this.incubationService}
          getConvocatorias={this.getConvocatorias}
        />
      )
    });
  }
  updateModal(number) {
    this.setState({
      modal: (
        <UpdateConvocatoria
          closeModal={this.closeUpdateModal}
          setError={this.errorAlert}
          pushNotification={this.props.pushNotification}
          number={number}
          jumpToConvocatoriaTab={() => this.handleSelect(1)}
          incubationService={this.incubationService}
          getConvocatorias={this.getConvocatorias}
        />
      )
    });
  }

  getUsers() {
    this.userService
      .getReviewers()
      .then(res => {
        let users = [];
        res.users.forEach(function(user){
          users.push( {value: user.id, label: user.username} );
        })
        //console.log(users);
        this.setState({ users: users });
      })
      .catch(err => {
        console.log(err);
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se obtenia la información de los contactos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  assignProject(tableName, selectedRows, multipleSelect, callbackComponent) {
    const table = getTable(tableName);
    this.incubationService
      .assignProject(selectedRows, multipleSelect)
      .then(() => {
        this.showAlert(
          <SweetAlert
            success
            style={{ display: "block", marginTop: "-100px" }}
            title="Asignar Proyetos"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
            confirmBtnText="Aceptar"
          >
            Proyectos asignados correctamente
          </SweetAlert>
        );
        callbackComponent();
        refreshSelected();
        table.clear();
        table.ajax.reload();
        table.draw();
      })
      .catch(err => {
        console.log(err);
        this.hideAlert();
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se asignaban los proyectos, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  render(){
    if (!this.state.convocatorias || !this.state.estados) {
      return (<div className="main-content"></div>)
    }
    return (
      <div className="main-content">
        {this.state.alert}
        {this.state.modal}
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <div>
                    <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="incubacion-tabs">
                      {this.props.currentUser.roles[0] === 'Coordinador' &&
                        <Tab eventKey={1} title="Convocatoria">
                          <Convocatoria openCreateModal={this.createModal} openUpdateModal={this.updateModal} />
                        </Tab>
                      }
                      <Tab eventKey={2} title="Idea">
                        <Idea
                          history={this.props.history} incubationService={this.incubationService}
                          setError={this.errorAlert} preSelect={this.preSelect} archive={this.archive}
                          showAlert={this.showAlert} hideAlert={this.hideAlert}
                          userService={this.userService} users={this.state.users}
                          convocatorias={this.state.convocatorias} estados={this.state.estados}
                          currentRole={this.props.currentUser.roles[0]}
                          assignProject={this.assignProject}
                        />
                      </Tab>
                      <Tab eventKey={3} title="Pre Selección" >
                        {this.state.key === 3 &&
                          <PreSelectionTab
                            incubationService={this.incubationService} setError={this.errorAlert}
                            history={this.props.history} preIncubate={this.preIncubate}
                            showAlert={this.showAlert} hideAlert={this.hideAlert}
                            convocatorias={this.state.convocatorias}
                            currentRole={this.props.currentUser.roles[0]}
                            archive={this.archive}
                          />
                        }
                      </Tab>
                      <Tab eventKey={4} title="Pre Incubación">
                        <PreIncubationTab
                          history={this.props.history} incubate={this.incubate}
                          showAlert={this.showAlert} hideAlert={this.hideAlert}
                          convocatorias={this.state.convocatorias} estados={this.state.estados}
                          currentRole={this.props.currentUser.roles[0]}
                          users={this.state.users}
                          assignProject={this.assignProject}
                          preSelect={this.preSelect} archive={this.archive}
                        />
                      </Tab>
                      <Tab eventKey={5} title="Incubación">
                        <IncubationTab
                          history={this.props.history} postIncubate={this.postIncubate}
                          showAlert={this.showAlert} hideAlert={this.hideAlert}
                          convocatorias={this.state.convocatorias} estados={this.state.estados}
                          currentRole={this.props.currentUser.roles[0]}
                          users={this.state.users}
                          assignProject={this.assignProject}
                          archive={this.archive}
                        />
                      </Tab>
                      <Tab eventKey={6} title="Graduados">
                        <PostIncubationTab
                          history={this.props.history}
                          convocatorias={this.state.convocatorias} estados={this.state.estados}
                        />
                      </Tab>
                    </Tabs>
                  </div>
                }
            />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}
export default Main;



// WEBPACK FOOTER //
// ./src/views/Incubation/Main.jsx